// extracted by mini-css-extract-plugin
export default {"object-renderer":"objectRenderer_object-renderer__d0PyY"};